module.exports = __webpack_public_path__ + "static/media/CTLA_9-540w.e139b0ef.jpg";